import * as React from 'react';
import { useContext } from 'react';

import type { DomainWithSubdomain } from 'bundles/unified-career-academy/types/enterprise';

const DomainsContext = React.createContext<Array<DomainWithSubdomain> | undefined>(undefined);

export const useDomains = () => {
  const domains = useContext(DomainsContext);

  return domains;
};

export default DomainsContext;
